import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Phone, X, Sparkles } from "lucide-react";

const StickyContactButton = ({ onOpenChat }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="sticky-contact">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            className="absolute bottom-20 right-0 w-56 bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden"
            data-testid="contact-menu"
          >
            <div className="bg-[#0A2342] px-5 py-3">
              <p className="text-white font-semibold text-sm">Contact Bryan</p>
              <p className="text-slate-400 text-xs">I respond within minutes</p>
            </div>
            <div className="p-2">
              <a
                href="tel:+19362241484"
                className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-50 transition-colors"
                data-testid="contact-call"
              >
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <Phone className="w-5 h-5 text-green-600" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0A2342]">Call Me</p>
                  <p className="text-xs text-slate-500">(936) 224-1484</p>
                </div>
              </a>
              <a
                href="sms:+19362241484?body=Hi%20Bryan%2C%20I%20found%20you%20on%20Urban%20Nest%20Quest%20and%20I%27m%20looking%20for%20an%20apartment!"
                className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-50 transition-colors"
                data-testid="contact-text"
              >
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <MessageCircle className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0A2342]">Text Me</p>
                  <p className="text-xs text-slate-500">(936) 224-1484</p>
                </div>
              </a>
              {onOpenChat && (
                <button
                  type="button"
                  onClick={() => { setOpen(false); onOpenChat(); }}
                  className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-50 transition-colors text-left"
                  data-testid="contact-chat-ai"
                >
                  <div className="w-10 h-10 bg-[#C8A96B]/20 rounded-full flex items-center justify-center">
                    <Sparkles className="w-5 h-5 text-[#9c7f45]" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-[#0A2342]">Chat with Nest</p>
                    <p className="text-xs text-slate-500">AI assistant · instant answers</p>
                  </div>
                </button>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen(!open)}
        className={`w-16 h-16 rounded-full shadow-xl flex items-center justify-center transition-all ${
          open
            ? "bg-[#1F2A44] hover:bg-[#0A2342] rotate-0"
            : "bg-[#0A2342] hover:bg-[#1F2A44] ring-2 ring-[#C8A96B]/70"
        }`}
        data-testid="sticky-contact-toggle"
      >
        {open ? (
          <X className="w-6 h-6 text-[#C8A96B]" />
        ) : (
          <MessageCircle className="w-7 h-7 text-[#C8A96B]" />
        )}
      </button>
    </div>
  );
};

export default StickyContactButton;
